import React from 'react';
import { FaPython, FaPhp, FaCode, FaMicrochip, FaLanguage } from 'react-icons/fa';

interface BadgeProps {
    icon: React.ReactNode;
    label: string;
    color?: string;
}

const Badge: React.FC<BadgeProps> = ({ icon, label, color = "blue" }) => (
    <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-gray-800/80 border border-white/20 hover:border-white/40 transition-all duration-300">
        <span className="text-lg">{icon}</span>
        <span className="text-sm font-medium text-white">{label}</span>
    </div>
);

const ProfessionalBadges: React.FC = () => {
    return (
        <div className="flex flex-wrap gap-2 justify-center mt-4">
            {/* Programming Languages */}
            <Badge icon={<FaPython />} label="Python" />
            <Badge icon={<FaPhp />} label="PHP" />
            <Badge icon={<FaCode />} label="C/C++" />

            {/* IoT */}
            <Badge icon={<FaMicrochip />} label="ESP32 / IoT" />

            {/* Languages */}
            <Badge icon={<FaLanguage />} label="🇬🇧 EN" />
            <Badge icon={<FaLanguage />} label="🇩🇪 DE" />
            <Badge icon={<FaLanguage />} label="🇷🇺 RU" />
            <Badge icon={<FaLanguage />} label="🇺🇦 UA" />
        </div>
    );
};

export default ProfessionalBadges;